import type { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { CheckboxRenderer } from "../../../../../controls/ag-grid/components/CheckboxRenderer";
import { GridButtonsV2 } from "../../../../../controls/buttons/GridButtonsV2";
import type { CatalogMold } from "../../../models/CatalogMold";
import { useCatalogMoldContext } from "../context/CatalogMoldContext";

const cellStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

type Props = {
  setMold: (mold: CatalogMold) => void;
  setShowModal: (show: "new" | "edit" | "delete" | "") => void;
  showContextMenu: Function;
};

export const useTableData = ({
  setMold,
  setShowModal,
  showContextMenu,
}: Props) => {
  const { state } = useCatalogMoldContext();

  const rows: CatalogMold[] =
    state.molds?.map((mold: CatalogMold) => ({
      ...mold,
    })) || [];

  const columnDefs: ColDef[] = [
    {
      field: "MoldName",
      headerName: "Name",
      minWidth: 20,
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "MoldSizeName",
      headerName: "Mold Size",
      minWidth: 20,
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "Height",
      headerName: "Height",
      minWidth: 20,
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "Width",
      headerName: "Width",
      minWidth: 20,
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "Code",
      headerName: "Code",
      minWidth: 20,
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "LbsPerInch",
      headerName: "Lbs Per Inch",
      minWidth: 20,
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "Enabled",
      headerName: "Enabled",
      minWidth: 20,
      flex: 1,
      cellRenderer: CheckboxRenderer,
      cellStyle: cellStyle,
    },
    {
      field: "-",
      cellRenderer: GridButtonsV2,
      cellRendererParams: (params: ICellRendererParams) => ({
        setData: setMold,
        data: params.data as CatalogMold,
        setShowModal: setShowModal,
        showContextMenu: () =>
          showContextMenu(event, params.data, "moldContext"),
      }),
      wrapText: false,
      autoHeight: false,
      wrapHeaderText: false,
      headerName: "",
      sortable: false,
      flex: 1,
      minWidth: 330,
      filter: false,
      autoHeaderHeight: true,
    },
  ];
  return { rows, columnDefs };
};
